(function(){
'use strict';
// PUBLICACION: activado por defecto en fichas de funda; ?kira_editorial=0 permite comparar el original.
// No toca valores de input, recargos, reglas, precios ni eventos de compra.
if(new URLSearchParams(location.search).get("kira_editorial")==="0")return;
const norm=s=>String(s||'').normalize('NFD').replace(/[\u0300-\u036f]/g,'').replace(/\s+/g,' ').trim().toUpperCase();
const $=(s,r=document)=>r.querySelector(s);
const $$=(s,r=document)=>Array.from(r.querySelectorAll(s));
const brandNames=new Set(['IPHONE','SAMSUNG','HUAWEI/HONOR','MOTOROLA','XIAOMI','LG','OPPO','REALME','ONE PLUS','ZTE','VIVO','NOTHING PHONE','PIXEL','INFINIX','RED MAGIC','TECNO']);
let mounted=false;
function make(tag,cls,text){
 const n=document.createElement(tag);
 if(cls)n.className=cls;
 if(text!==undefined)n.textContent=text;
 return n;
}
function findLabel(group,pattern){
 // Consider only short labels; never rename an existing selection or field.
 return $$('label,legend,h2,h3,h4,.gpo-label,.gpo-option-title,.gpo-form__label',group)
  .find(n=>n.textContent && n.textContent.trim().length<90 && pattern.test(norm(n.textContent)));
}
function setStep(group,pattern,num){
 if(!group)return;
 const label=findLabel(group,pattern);
 if(label&&!label.classList.contains('kira-editorial-label')){
  label.classList.add('kira-editorial-label');
  label.setAttribute('data-kira-step',num);
 }
}
// Las descripciones inferiores de Globo se muestran completas y sin reescritura.
/* Ficha contextual de tipo de funda: lee selección, no escribe en Globo. */
const caseDetails={
 "acrigel":{name:"Acrigel Anti-Shock",price:"Incluida",badge:"MÁS POPULAR",points:["Acrílico rígido con bordes flexibles","Transparente y cómoda para uso diario"],img:"https://cdn.shopify.com/s/files/1/0746/3334/7391/files/image_18.webp?v=1779325577"},
 "acrigel-wireless":{name:"Acrigel carga inalámbrica",price:"+ $35 MXN",badge:"ARO INTEGRADO",points:["Transparente con aro para carga inalámbrica","Para dispositivos y cargadores compatibles"],img:"https://cdn.shopify.com/s/files/1/0746/3334/7391/files/image_20.webp?v=1779327390"},
 "mate":{name:"Funda Mate · base negra",price:"+ $75 MXN",badge:"MARCO NEGRO",points:["Base negra y superficie mate","Estructura de acrílico y TPU"],img:"https://cdn.shopify.com/s/files/1/0746/3334/7391/files/image_19.webp?v=1779326453"},
 "mate-wireless":{name:"Funda Mate carga inalámbrica",price:"+ $99 MXN",badge:"MARCO NEGRO",points:["Base negra y superficie mate con aro","Carga inalámbrica en equipos compatibles"],img:"https://cdn.shopify.com/s/files/1/0746/3334/7391/files/image_21.webp?v=1779328594"},
 "three":{name:"3 en 1 (360°)",price:"+ $75 MXN",badge:"TRES PIEZAS",points:["Piezas frontal, lateral y posterior","Cobertura para el uso cotidiano"],img:"https://cdn.shopify.com/s/files/1/0746/3334/7391/files/image_22.webp?v=1779332008"}
};
function caseFromText(value){
 const v=norm(value);
 if(!v||v.length>130)return null;
 if(v.includes('MATE')&&(v.includes('INALAMBRICA')||v.includes('MAG SAFE')||v.includes('MAGSAFE')))return 'mate-wireless';
 if(v.includes('ACRIGEL')&&(v.includes('INALAMBRICA')||v.includes('MAG SAFE')||v.includes('MAGSAFE')))return 'acrigel-wireless';
 if(v.includes('3 EN 1')||v.includes('360'))return 'three';
 if(v.includes('MATE'))return 'mate';
 if(v.includes('ACRIGEL'))return 'acrigel';
 return null;
}
function selectedCase(typeGroup){
 if(!typeGroup)return null;
 // Value checked by Globo is the most reliable signal.
 const inputs=$$('input[type="radio"]:checked,input[type="checkbox"]:checked,option:checked',typeGroup);
 for(const input of inputs){
   const id=caseFromText(input.value)||caseFromText(input.getAttribute('data-value'));
   if(id)return id;
   const optionLabel=input.id&&$('label[for="'+CSS.escape(input.id)+'"]',typeGroup);
   const parent=input.closest('label,.gpo-swatch,.gpo-swatch__item,[role="radio"]')||input.parentElement;
   const match=caseFromText((optionLabel||parent)?.textContent);
   if(match)return match;
 }
 for(const marker of $$('[aria-checked="true"],[aria-selected="true"],[data-selected="true"],.gpo-selected,.is-selected,.gpo-swatch.selected,.gpo-swatch.active,.gpo-swatch.checked',typeGroup)){
   const elem=marker.closest('label,.gpo-swatch,.gpo-swatch__item,[role="radio"]')||marker;
   const match=caseFromText(elem.getAttribute('data-value'))||caseFromText(elem.getAttribute('aria-label'))||caseFromText(elem.textContent);
   if(match)return match;
 }
 return null;
}
function contextImageFromExisting(key){
 const lower=$('.kp-guide-start');
 if(!lower)return null;
 const cards=$$('.kp-type-card',lower);
 const wanted={"acrigel":0,"mate":1,"acrigel-wireless":2,"mate-wireless":3,"three":4}[key];
 return cards[wanted]?.querySelector('img')?.getAttribute('src')||null;
}
function createContext(typeGroup){
 const panel=make('aside','kira-case-context');
 panel.id='kira-case-context';
 panel.setAttribute('aria-label','Información de la funda seleccionada');
 panel.setAttribute('aria-live','polite');
 panel.setAttribute('aria-atomic','true');
 const photo=make('div','kira-case-context__media');
 const img=make('img','kira-case-context__photo');
 img.loading='lazy';img.decoding='async';img.width=300;img.height=340;
 photo.append(img);
 const content=make('div','kira-case-context__body');
 const eyebrow=make('p','kira-case-context__kicker','CONOCE TU FUNDA');
 const title=make('strong','kira-case-context__title');
 const tag=make('span','kira-case-context__tag');
 const badge=make('span','kira-case-context__badge');
 const points=make('ul','kira-case-context__points');
 const note=make('p','kira-case-context__note','La selección y el recargo se confirman abajo en Globo.');
 const placeholder=make('p','kira-case-context__placeholder','Selecciona abajo un tipo de funda para conocer sus características.');
 content.append(eyebrow,badge,title,tag,points,note,placeholder);
 panel.append(photo,content);
 // La tarjeta de referencia acompaña el encabezado, antes del paso 01;
 // las opciones nativas de Globo quedan consecutivas sin interrupciones.
 const intro=$('.kira-editorial-intro',typeGroup.parentElement||document);
 if(intro)intro.insertAdjacentElement('afterend',panel);
 else typeGroup.insertAdjacentElement('beforebegin',panel);
 let last='';
 function render(key){
   const chosen=caseDetails[key]||null;
   if(last===key)return;
   last=key||'';
   panel.classList.toggle('is-empty',!chosen);
   if(!chosen){img.removeAttribute('src');title.textContent='';badge.textContent='';tag.textContent='';points.replaceChildren();return;}
   img.src=contextImageFromExisting(key)||chosen.img;
   img.alt='Foto real de funda '+chosen.name;
   title.textContent=chosen.name;
   tag.textContent=chosen.price;
   points.replaceChildren();
   chosen.points.forEach(p=>points.append(make('li','',p)));
   badge.textContent=chosen.badge;
 }
 // No inventar una selección: mostrar detalles solo al detectar marcado.
 render(selectedCase(typeGroup));
 const sync=()=>render(selectedCase(typeGroup));
 typeGroup.addEventListener('input',()=>setTimeout(sync,30));
 typeGroup.addEventListener('change',()=>setTimeout(sync,50));
 typeGroup.addEventListener('click',event=>{
   const choice=event.target.closest('label,[role="radio"],.gpo-swatch,.gpo-swatch__inner,.gpo-swatch__item');
   const clicked=choice&&caseFromText(choice.getAttribute('data-value')||choice.textContent);
   if(!clicked){setTimeout(sync,100);return;}
   // Fall back to the actual tapped swatch only if Globo does not expose a selected input.
   setTimeout(()=>render(selectedCase(typeGroup)||clicked),120);
 });
 document.body.classList.add('kira-editorial-context-ready');
 // Globo can re-render the carousel when a conditional field changes.
 const observer=new MutationObserver(()=>{
   if(!typeGroup.isConnected){observer.disconnect();return;}
   const actual=selectedCase(typeGroup);
   if(actual&&actual!==last)render(actual);
 });
 observer.observe(typeGroup,{attributes:true,subtree:true,childList:true,attributeFilter:['class','checked','aria-checked','aria-selected','data-selected']});
 return panel;
}

function labelBrandButtons(){
 $$('.kira-marcas').forEach(group=>{
  $$('button,label,[role="radio"]',group).forEach(node=>{
   const txt=norm(node.textContent);
   if(brandNames.has(txt))node.classList.add('kira-editorial-brand-chip');
  });
 });
}
function findDuplicatePromo(root,type){
 const price=$('.kira-case-price-offer');
 if(!price||!type)return;
 const nodes=$$('div,p,section',root);
 let found=null;
 for(const n of nodes){
  if(n===type||n.contains(type)||n.querySelector('input,select,button'))continue;
  const txt=norm(n.textContent);
  if(txt.length<35||txt.length>240)continue;
  if(!txt.includes('2X1 EN ACRIGEL')||!txt.includes('OPCIONES ADICIONALES CON COSTO'))continue;
  // Prefer the outermost pure promotional node, but never the form itself.
  if(!found || n.contains(found))found=n;
 }
 if(found && !found.contains(type)){
  found.classList.add('kira-editorial-redundant');
 }
}
function mount(){
 if(mounted)return true;
 const info=$('.product-information');
 const type=$('.kira-tipo-funda',info||document);
 if(!info||!type||!type.parentNode)return false;
 const root=$('.kira-configurador',info)||type.parentElement;
 // Only after verifying the correct case product selector is present.
 document.body.classList.add('kira-editorial-on');
 const intro=make('header','kira-editorial-intro');
 intro.innerHTML='<h2>HAZLA TUYA.</h2><p>Tu funda, tu celular, tu acabado.</p><ol class="kira-v15-roadmap" aria-label="Tres decisiones para personalizar tu funda"><li><b>01</b><span>FUNDA</span></li><li><b>02</b><span>CELULAR</span></li><li><b>03</b><span>ACABADO</span></li></ol>';
 type.insertAdjacentElement('beforebegin',intro);
 setStep(type,/TIPO DE FUNDA/,'01');
 $$('.kira-marcas',info).forEach(el=>setStep(el,/MARCA|SELECCIONA LA MARCA/,'02'));
 $$('.kira-acabados',info).forEach(el=>setStep(el,/ESCOGE.*ESTILO DE IMPRESION|ACABADO/,'03'));
 findDuplicatePromo(root,type);
 // Mantener íntegros los textos descriptivos originales de cada opción de Globo.
 createContext(type);
 labelBrandButtons();
 mounted=true;
 // Globo may rebuild conditional brand buttons, so only restyle new labels. No prices touched.
 let calls=0;
 const observer=new MutationObserver(()=>{
  if(++calls>400){observer.disconnect();return;}
  labelBrandButtons();
 });
 observer.observe(root,{subtree:true,childList:true});
 setTimeout(()=>observer.disconnect(),20000);
 return true;
}
function start(){
 if(mount())return;
 const observer=new MutationObserver(()=>{if(mount())observer.disconnect();});
 observer.observe(document.body,{childList:true,subtree:true});
 document.addEventListener('gpoRenderCompleted',()=>mount(),{once:true});
 setTimeout(()=>observer.disconnect(),16000);
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
})();